import * as z from "zod";

export const getSandboxLoginConfig = {
  name: "getSandboxLoginConfig" as const,
  input: z.null(),
  output: z.object({
    enabled: z.boolean(),
    email: z.string().nullable(),
    teamId: z.string().nullable(),
  }),
};
